export enum DashboardTableActionKey {
  Edit = 'edit',
  Delete = 'delete',
}

export enum ConfigType {
  EXERCISE_CONTENT_TYPE = 'exercise_content_type',
  EXERCISE_CONTENT_CATEGORY = 'exercise_content_category',
}

export enum ExerciseContentType {
  DIY_UNPRESCRIBED = 'diy_unprescribed',
  DIY_PRESCRIBED = 'diy_prescribed',
  SUPERVISED = 'supervised',
}

export enum ExerciseContentCategory {
  CARDIO = 'cardio',
  STRENGTHENING = 'strengthening',
  WARMUP = 'warmup',
  COOLDOWN = 'cooldown',
  MIDPOINTCHEERUP = 'midpoint_cheer_up',
  ENDINGCHEERUP = 'ending_cheer_up',
}

export enum FunctionalTestType {
  'Auto scoring' = 'auto_scoring',
  'Manual scoring' = 'manual_scoring',
}

export enum FunctionalTestMethod {
  'Enter rep count' = 'enter_rep_count',
  'Enter score' = 'enter_score',
  'Time' = 'time',
  'Kg' = 'kg',
}

export enum LevelsExercise {
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}
